import SiteNav from '../components/layout/SiteNav'
import { useEffect, useState } from 'react'

export default function About() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '',
    employees: '', products: [], message: ''
  })
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('visible')
      }),
      { threshold: 0.1 }
    )
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el))
    return () => observer.disconnect()
  }, [])

  function toggleProduct(p) {
    setFormData(f => ({
      ...f,
      products: f.products.includes(p)
        ? f.products.filter(x => x !== p)
        : [...f.products, p]
    }))
  }

  function handleSubmit(e) {
    e.preventDefault()
    const subject = `GCW Inquiry from ${formData.name} — ${formData.company}`
    const body = `Name: ${formData.name}
Company: ${formData.company}
Email: ${formData.email}
Phone: ${formData.phone}
Employees: ${formData.employees}
Interested In: ${formData.products.join(', ')}
Message: ${formData.message}`
    window.location.href = `mailto:info@gallaghercollectiveworks.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    setSubmitted(true)
  }

  const productOptions = ['Collective Staff', 'Collective Hospitality', 'Collective Fleet', 'Collective Time', 'Creative Art Services', 'Not sure yet']
  const employeeOptions = ['1–10', '11–25', '26–50', '51–100', '100–250', '250+']

  return (
    <div style={{ fontFamily: "'Montserrat', sans-serif", background: '#F7F2EB', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Montserrat:wght@300;400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
        .reveal.visible { opacity: 1; transform: translateY(0); }
        .reveal-delay-1 { transition-delay: 0.1s; }
        .reveal-delay-2 { transition-delay: 0.2s; }
        .reveal-delay-3 { transition-delay: 0.3s; }
        .reveal-delay-4 { transition-delay: 0.4s; }
        .form-input { width: 100%; padding: 10px 14px; border: 1px solid #EDE6DA; border-radius: 8px; font-family: 'Montserrat', sans-serif; font-size: 13px; color: #2B2B2B; outline: none; background: #fff; transition: border-color 0.2s; }
        .form-input:focus { border-color: #B8734A; }
        .chip { padding: 7px 14px; border: 1px solid #EDE6DA; border-radius: 20px; font-size: 12px; font-weight: 500; cursor: pointer; transition: all 0.15s; background: #fff; color: #4A4A4A; font-family: 'Montserrat', sans-serif; }
        .chip.selected { background: rgba(184,115,74,0.1); border-color: #B8734A; color: #B8734A; font-weight: 600; }
        .primary-btn { background: #B8734A; color: #fff; border: none; border-radius: 8px; padding: 12px 28px; font-family: 'Montserrat', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
        .primary-btn:hover { background: #C9895F; }
      `}</style>

      <SiteNav />

      {/* About section */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center', marginBottom: '4rem' }}>
          <div>
            <div className="reveal" style={{ fontSize: 11, fontWeight: 600, color: '#B8734A', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '0.75rem' }}>About GCW</div>
            <h1 className="reveal reveal-delay-1" style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.6rem', fontWeight: 700, color: '#2B2B2B', lineHeight: 1.2, marginBottom: '1.25rem' }}>
              John & Tiffany Gallagher.<br /><em style={{ color: '#B8734A' }}>Built for small business.</em>
            </h1>
            <p className="reveal reveal-delay-2" style={{ fontSize: 13, color: '#6B7D6B', lineHeight: 1.9, marginBottom: '1rem' }}>
              John and Tiffany Gallagher are a husband-and-wife team based in Ellsworth, Maine. John brings an extensive background in technology, IT management, and business strategy — translating complex systems into practical solutions and leading implementation with precision and care.
            </p>
            <p className="reveal reveal-delay-3" style={{ fontSize: 13, color: '#6B7D6B', lineHeight: 1.9, marginBottom: '1rem' }}>
              Tiffany brings over two decades of operational management and human resources expertise — onboarding, compliance, payroll, training, SOP development, team management, and day-to-day operations across organizations of every size. If it touches people and process, Tiffany has not only done it — she has built the system around it.
            </p>
            <p className="reveal reveal-delay-3" style={{ fontSize: 13, color: '#6B7D6B', lineHeight: 1.9, marginBottom: '1.5rem' }}>
              Together, John and Tiffany founded Gallagher Collective Works with a simple belief: small businesses deserve powerful tools without the enterprise price tag or complexity.
              <strong style={{ color: '#B8734A', display: 'block', marginTop: '0.75rem', fontSize: 14, letterSpacing: '0.05em' }}>Gallagher Collective Works — Built to Work. Made for You.</strong>
            </p>
          </div>
          <div className="reveal reveal-delay-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[
              { val: 'Ellsworth', label: 'Based in Maine' },
              { val: '2', label: 'Co-Owners' },
              { val: '2', label: 'Products Live' },
              { val: '20+', label: 'Years Experience' },
            ].map(s => (
              <div key={s.label} style={{ background: '#fff', border: '1px solid #EDE6DA', borderRadius: 12, padding: '1.5rem', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', color: '#B8734A', fontWeight: 700, lineHeight: 1, marginBottom: 6 }}>{s.val}</div>
                <div style={{ fontSize: 11, color: '#8A9E8A', textTransform: 'uppercase', letterSpacing: '0.08em', lineHeight: 1.4 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact form */}
        <div style={{ background: '#2B2B2B', borderRadius: 20, padding: '3rem' }}>
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#B8734A', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '0.75rem' }}>Let's work together</div>
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2rem', fontWeight: 700, color: '#fff', marginBottom: '0.75rem' }}>Tell us about your business.</h2>
            <p style={{ fontSize: 13, color: 'rgba(217,195,163,0.5)', lineHeight: 1.8 }}>Fill out the form and we'll be in touch within one business day.</p>
          </div>

          {submitted ? (
            <div style={{ background: 'rgba(74,124,89,0.15)', border: '1px solid #4A7C59', borderRadius: 16, padding: '3rem', textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: '1rem' }}>✓</div>
              <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.5rem', color: '#fff', marginBottom: '0.75rem' }}>We'll be in touch!</div>
              <div style={{ fontSize: 13, color: 'rgba(217,195,163,0.5)', lineHeight: 1.8 }}>John or Tiffany will respond within one business day.</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ maxWidth: 700, margin: '0 auto' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 6 }}>Full Name *</label>
                  <input className="form-input" required placeholder="Your full name" value={formData.name} onChange={e => setFormData(f => ({...f, name: e.target.value}))} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 6 }}>Company Name</label>
                  <input className="form-input" placeholder="Your company" value={formData.company} onChange={e => setFormData(f => ({...f, company: e.target.value}))} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 6 }}>Email Address *</label>
                  <input className="form-input" type="email" required placeholder="your@email.com" value={formData.email} onChange={e => setFormData(f => ({...f, email: e.target.value}))} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 6 }}>Phone Number</label>
                  <input className="form-input" placeholder="(207) 555-0000" value={formData.phone} onChange={e => setFormData(f => ({...f, phone: e.target.value}))} />
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 10 }}>Number of Employees</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {employeeOptions.map(opt => (
                    <button key={opt} type="button" className={`chip ${formData.employees === opt ? 'selected' : ''}`}
                      onClick={() => setFormData(f => ({...f, employees: opt}))}>
                      {opt}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 10 }}>What are you interested in?</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {productOptions.map(opt => (
                    <button key={opt} type="button" className={`chip ${formData.products.includes(opt) ? 'selected' : ''}`}
                      onClick={() => toggleProduct(opt)}>
                      {opt}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(217,195,163,0.5)', fontWeight: 600, marginBottom: 6 }}>Tell us about your business</label>
                <textarea className="form-input" rows={4} placeholder="What challenges are you facing? What does your team look like?" value={formData.message} onChange={e => setFormData(f => ({...f, message: e.target.value}))} style={{ resize: 'vertical' }} />
              </div>
              <button type="submit" className="primary-btn" style={{ width: '100%', fontSize: 14, padding: '14px' }}>
                Send Inquiry → We'll Respond Within One Business Day
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}